import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { KpiCardComponent, KpiOption } from '../../../shared/kpi-card/kpi-card.component';
import { TIMESPAN_OPTIONS, TimespanOption } from '../../../../../models/account-creation-point.model';

/** UXPin "AppCloud Accounts — 1,403 Total" KPI card with a Total / 30 / 60 / 90 days menu. */
@Component({
    selector: 'r1-accounts-kpi',
    template: `
        <r1-kpi-card
            title="AppCloud Organizations"
            [value]="count()"
            [label]="option().readAs"
            [options]="options"
            (optionChange)="pick($event)" />
    `,
    styles: `
        :host {
            display: block;
            height: 100%;
        }
    `,
    imports: [KpiCardComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountsKpiComponent {
    count = input.required<number | null>();
    option = input.required<TimespanOption>();
    optionChange = output<TimespanOption>();

    readonly options = TIMESPAN_OPTIONS;

    pick(option: KpiOption) {
        const match = TIMESPAN_OPTIONS.find(item => item.readAs === option.readAs);
        if (match) {
            this.optionChange.emit(match);
        }
    }
}
